import { DefaultBaseBackgroundRenderContribution, getBackgroundImage } from "./base-contribution-render";

import { BaseRenderContributionTime } from "../../../../common/enums";

export class DefaultGroupBackgroundRenderContribution extends DefaultBaseBackgroundRenderContribution {
    constructor() {
        super(...arguments), this.time = BaseRenderContributionTime.beforeFillStroke;
    }
    drawShape(graphic, context, x, y, doFill, doStroke, fVisible, sVisible, graphicAttribute, drawContext, fillCb, strokeCb) {
        const {background: background, backgroundOpacity: backgroundOpacity = graphicAttribute.backgroundOpacity, opacity: opacity = graphicAttribute.opacity, backgroundMode: backgroundMode = graphicAttribute.backgroundMode, backgroundFit: backgroundFit = graphicAttribute.backgroundFit, backgroundKeepAspectRatio: backgroundKeepAspectRatio = graphicAttribute.backgroundKeepAspectRatio, backgroundScale: backgroundScale = graphicAttribute.backgroundScale, backgroundOffsetX: backgroundOffsetX = graphicAttribute.backgroundOffsetX, backgroundOffsetY: backgroundOffsetY = graphicAttribute.backgroundOffsetY, backgroundClip: backgroundClip = graphicAttribute.backgroundClip, backgroundPosition: backgroundPosition = graphicAttribute.backgroundPosition} = graphic.attribute;
        if (background) if (graphic.backgroundImg && graphic.resources) {
            const res = graphic.resources.get(getBackgroundImage(background));
            if (!res || "success" !== res.state || !res.data) return;
            context.highPerformanceSave(), context.setTransformFromMatrix(graphic.parent.globalTransMatrix, !0);
            const b = graphic.AABBBounds;
            context.globalAlpha = backgroundOpacity * opacity, backgroundClip && context.clip(), 
            this.doDrawImage(context, res.data, b, {
                backgroundMode: backgroundMode,
                backgroundFit: backgroundFit,
                backgroundKeepAspectRatio: backgroundKeepAspectRatio,
                backgroundScale: backgroundScale,
                backgroundOffsetX: backgroundOffsetX,
                backgroundOffsetY: backgroundOffsetY,
                backgroundPosition: backgroundPosition
            }), context.highPerformanceRestore(), context.setTransformForCurrent();
        } else context.highPerformanceSave(), context.globalAlpha = backgroundOpacity * opacity, 
        context.fillStyle = background, context.fill(), context.highPerformanceRestore();
    }
}

export const defaultGroupBackgroundRenderContribution = new DefaultGroupBackgroundRenderContribution;
//# sourceMappingURL=group-contribution-render.js.map
